
import { defineComponent } from "vue"
import CardLanguagesForm from "@/components/card_languages/Form.vue"

export default defineComponent({
  components: {
    CardLanguagesForm
  }
})
